// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"8aecab6a","67":"2539950b","212":"ccd51ac3","625":"43df4d5c"}[chunkId] + ".chunk.css";
};